module.exports = __webpack_public_path__ + "static/media/icon-spinner.acf46726.png";